export default __webpack_public_path__ + "static/media/assign.a668926c.svg";